export enum AuthenticationSource {
  Local,
  RemoteEdiProd,
  Nexus,
  MyAccountGateway,
}
